export enum WorkspaceRoles {
    ANALYST = "Analyst",
    REVIEWER = "Reviewer",
    APPROVER = "Approver",
    MANAGEMENT = "Management",
}